import { Grid, Typography } from '@mui/material';
import { ROUTE_HELP_FEEDBACK } from '@/app/routes';
import { TypographyLink } from '@/components/common/TypographyLink';
import React, { FC, Fragment } from 'react';

export const UserLockedMessage: FC = () => {
  return (
    <Fragment>
      <Grid container={true} direction={'column'} alignItems={'center'} spacing={4} mt={14} mb={17}>
        <Grid item={true}>
          <Typography variant={'h2'} textAlign={'center'}>
            {'Личный кабинет был удален по вашему запросу. Для восстановления заполните '}
            <a href={ROUTE_HELP_FEEDBACK} target={'_blank'} rel={'noreferrer'}>
              <TypographyLink>{'форму обратной связи'}</TypographyLink>
            </a>
          </Typography>
        </Grid>
      </Grid>
    </Fragment>
  );
};
